import { render, staticRenderFns } from "./IngressoLavorazione.vue?vue&type=template&id=7bdbf981"
import script from "./IngressoLavorazione.vue?vue&type=script&lang=js"
export * from "./IngressoLavorazione.vue?vue&type=script&lang=js"
import style0 from "./IngressoLavorazione.vue?vue&type=style&index=0&id=7bdbf981&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports